export var RestrictedFeatureEnum = {
  socialAuth: 'social_auth',
  languages: 'languages',
  currencies: 'currencies',
  attributes: 'attributes',
  email: 'email_white_labelling',
  bulkEditCategories: 'bulk_edit_categories',
  bulkEditListings: 'bulk_edit_listings',
  bulkEditAccounts: 'bulk_edit_accounts',
  bulkOperations: 'bulk_operations',
  bundleOperations: 'bundle_operations',
  fulfillment_by_platform: 'fulfillment_by_platform',
  variantTypes: 'simple_variants',
  customizeEmailTemplates: 'customize_email_templates',
  headlessApi: 'headless_api',
  auditLogs: 'audit_logs',
  rbac: 'rbac',
  createOrder: 'create_order',
  createListing: 'create_listing',
  api: 'api',
  payuLatam: 'payulatam',
  mangoPay: 'mangopay',
  payDunya: 'paydunya',
  whiteLabel: 'whitelabel',
  prioritySupport: 'priority_support',
};
